import dayjs from 'dayjs';
import React, { FC } from 'react';
import Modal from './common/Modal/Modal';

interface ModalConfirmNoPreimgProps {
  isShow: boolean;
  timelock?: number | null;
  onRequestClose: () => void;
}

const ModalConfirmNoPreimg: FC<ModalConfirmNoPreimgProps> = ({
  isShow,
  timelock,
  onRequestClose,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      title="CONFIRM"
      onClose={onRequestClose}
      explanation={`The conversion to a To-chain wallet cannot be made. You can get a refund from ${
        timelock
          ? dayjs(timelock * 1000)
              .utc()
              .format(`MM/DD HH:mm`)
          : ``
      } (UTC) 
so please try again after processing the refund.`}
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalConfirmNoPreimg;
